import React, { useState } from "react"
import { useForm } from "react-hook-form"
import { IFormProps } from "./interfaces"
import Input from "./input"
import { useTranslation } from "react-i18next"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import { Button } from "../button"

export interface WorkWithUsFormProps extends IFormProps {
  actionUrl?: string
}

type Inputs = {
  firstname: string
  lastname: string
  email: string
  phone: string
}

const WorkWithUsForm: React.FC<WorkWithUsFormProps> = ({
  onFinish,
  initialValues = { newsletter: true },
  actionUrl,
}) => {
  const { t } = useTranslation()
  const [schema] = useState(
    yup
      .object({
        firstname: yup
          .string()
          .required(t("error:firstnameRequired"))
          .max(256, "error:maxLengthExceeded"),
        lastname: yup
          .string()
          .required(t("error:lastnameRequired"))
          .max(256, t("error:maxLengthExceeded")),
        email: yup.string().email().max(1000, t("error:maxLengthExceeded")),
        phone: yup.string(),
      })
      .required()
  )

  const form = useForm<Inputs>({
    defaultValues: initialValues,
    resolver: yupResolver(schema),
  })

  const formProps = actionUrl
    ? { action: actionUrl, method: "POST" }
    : { onSubmit: form.handleSubmit(onFinish) }

  return (
    <form {...formProps} className={"space-y-8"}>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <Input label={t("label:firstname")} name="firstname" form={form} />
        <Input label={t("label:lastname")} name="lastname" form={form} />
        <Input label={t("label:email")} name="email" form={form} />
        <Input label={t("label:phone")} name="phone" form={form} />
      </div>

      <div className={"text-center w-2/4 mx-auto"}>
        <Button block htmlType="submit" type="primary">
          <span className={"text-lg"}> {t("button:send")}</span>
        </Button>
      </div>
    </form>
  )
}

export default WorkWithUsForm
